export default __webpack_public_path__ + "static/media/bediasultan1.b6dbd284.jpg";